<template>
	<div class="alert alert-white" :class="classVariant" role="alert">
		<div class="icon mx-auto" v-html="icone"></div>
		<div class="texto-alert text-center" v-html="texto"></div>
	</div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps({
	variant: {
		type: String,
		default: "primary",
	},
	texto: String,
	icone: {
		type: String,
		default: '<span class="material-symbols-outlined">error</span>',
	},
})
const classVariant = computed(() => `alert-${props.variant}`)
</script>

<style>
.alert.alert-white {
	display: flex;
	align-items: center;
	width: 100%;
	border-radius: 0.5rem;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);
	padding: 1rem;
	gap: 1rem;
	flex-wrap: wrap;
	background: linear-gradient(to bottom, #fff, #f9f9f9);
	border: 1px solid #cacaca;
	color: #404040;
}

.alert-white .icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 45px;
	height: 45px;
	min-width: 45px;
	min-height: 45px;
}

.alert-white .icon > span, .alert-white .icon > i {
	font-size: 60px;
}

.texto-alert {
	flex: 1 1 auto;
	word-wrap: break-word;
	text-align: left;
	font-size: 0.95rem;
}

.alert-white.alert-success {
    color: #3c763d;
    border-color: #3cd458;
}
.alert-white.alert-success .icon {
    border-color: #3cd458;
}

.alert-white.alert-info {
    color: #926dde;
    border-color: #926dde;
}
.alert-white.alert-info .icon {
    border-color: #926dde;
}

.alert-white.alert-warning {
    color: #ffba00;
    border-color: #ffba00;
}
.alert-white.alert-warning .icon {
    border-color: #ffba00;
}

.alert-white.alert-danger {
    color: #ff4954;
    border-color: #ff4954;
}
.alert-white.alert-danger .icon {
    border-color: #ff4954;
}
</style>